import type { OperatorOrganization } from '@/features/auth/auth-model'

export type OrganizationCompanyFormState = {
  street: string
  streetNumber: string
  country: string
  poBox: string
  city: string
  subDivision: string
  street2: string
  postCode: string
  localStreet: string
  localStreetNumber: string
  localSubDivision: string
  localPostCode: string
  localPoBox: string
  localCity: string
  localStreet2: string
  contactName: string
  contactEmail: string
  contactPhoneNumber: string
}

export function buildInitialFormState(
  organization: OperatorOrganization
): OrganizationCompanyFormState {
  return {
    street: organization.street ?? '',
    streetNumber: organization.streetNumber ?? '',
    country: organization.country ?? organization.placeOfRegistration ?? '',
    poBox: organization.poBox ?? '',
    city: organization.city ?? '',
    subDivision: organization.subDivision ?? '',
    street2: organization.street2 ?? '',
    postCode: organization.postCode ?? '',
    localStreet: organization.localStreet ?? '',
    localStreetNumber: organization.localStreetNumber ?? '',
    localSubDivision: organization.localSubDivision ?? '',
    localPostCode: organization.localPostCode ?? '',
    localPoBox: organization.localPoBox ?? '',
    localCity: organization.localCity ?? '',
    localStreet2: organization.localStreet2 ?? '',
    contactName: organization.contactName ?? '',
    contactEmail: organization.contactEmail ?? '',
    contactPhoneNumber: organization.contactPhoneNumber ?? '',
  }
}

export const LOCAL_INPUT_TO_STATE: Record<
  string,
  keyof OrganizationCompanyFormState
> = {
  street: 'localStreet',
  streetNumber: 'localStreetNumber',
  street2: 'localStreet2',
  postCode: 'localPostCode',
  poBox: 'localPoBox',
  city: 'localCity',
  subDivision: 'localSubDivision',
}
